import * as React from "react";
import styled from "styled-components";

import { BaseModal } from "Components/Modal/BaseModal";
import { CancelButton } from "Globals/Styles/Control/Buttons";
import { useObserver } from "mobx-react-lite";
import { EditContactModalDialogPaper } from "Views/Contacts/EditContactModal.styles";
import { PrimaryButton } from "Components/Buttons/Buttons";
import { Checkbox, FormControlLabel } from "@material-ui/core";

interface IAcknowledgementModalProps {
    open?: boolean;
    onClose(): void;
    onSubmit(): void;
    title: string;
    message: string;
    isLoading: boolean;
    saveText: string;
    canClose: boolean;
    hasAcknowledgedLessonsLearned: boolean;
    setHasAcknowledgedLessonsLearned(hasAcknowledgedLessonsLearned: boolean): void;
}

export const AcknowledgementModal: React.FunctionComponent<IAcknowledgementModalProps> = ({
    open,
    onClose,
    onSubmit,
    title,
    isLoading,
    message,
    saveText,
    canClose,
    hasAcknowledgedLessonsLearned,
    setHasAcknowledgedLessonsLearned,
}) => {
    //const [acknowledged, setAcknowledged] = React.useState(false);

    const renderBody = () => {
        return (
            <>
                {/* <div style={{ marginBottom: 12 }}>{message}</div> */}

                <FormControlLabel
                    control={
                        <Checkbox
                            checked={hasAcknowledgedLessonsLearned}
                            onChange={(_, checked) => setHasAcknowledgedLessonsLearned(checked)}
                            name="acknowledge-lessons-learned-checkbox"
                        />
                    }
                    label={message}
                />
            </>
        );
    };

    const handleConfirm = () => {
        if (!hasAcknowledgedLessonsLearned || isLoading) return;
        onSubmit();
    };

    return useObserver(() => (
        <BaseModal
            open={open}
            onClose={onClose}
            title={title}
            canClose={canClose}
            PaperComponent={(props) => <AcknowledgementModalDialogPaper {...props} />}
            actions={
                <>
                    {/* Confirm only enabled if the user has ticked the checkbox */}
                    <PrimaryButton displayName={saveText} execute={handleConfirm} fullWidth={false} canExecute={hasAcknowledgedLessonsLearned && !isLoading} />
                </>
            }
        >
            <div>{renderBody()}</div>
        </BaseModal>
    ));
};

export const AcknowledgementModalDialogPaper = styled(EditContactModalDialogPaper)`
    width: 100% !important;
    max-width: 800px;

    .MuiDialogActions-root > button {
        max-width: 262px;
    }

    .MuiDialogContent-root {
        margin-bottom: 20px;
    }

    .MuiDivider-root {
        background-color: rgba(0, 0, 0, 0.12) !important;
    }
`;
